/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
    var colorMap = {
      'black':'#1a1a1a','white':'#ffffff','red':'#cc2222','blue':'#2255cc',
      'navy':'#001f5b','green':'#228822','pink':'#f4a0b5','purple':'#7c4dff',
      'yellow':'#f5c842','orange':'#f08030','grey':'#999999','gray':'#999999',
      'brown':'#7a4a2a','beige':'#f0e6d3','cream':'#fffdd0','gold':'#cfa52a',
      'silver':'#c0c0c0','ivory':'#fffff0','tan':'#d2b48c','coral':'#ff6b6b',
      'teal':'#008080','mint':'#98ff98','lavender':'#e6e6fa','charcoal':'#36454f',
      'olive':'#808000','maroon':'#800000','turquoise':'#40e0d0','lime':'#32cd32',
      'indigo':'#4b0082','magenta':'#ff00ff','natural':'#f5f0e8','sand':'#c2b280',
      'white vintage gray':'#d8d0c8','collegiate blue':'#003366',
      'banana':'#f5e642','blossom':'#f4b8c8','blue jean':'#6f9fcc',
      'blue spruce':'#2e7d6e','bright salmon':'#ff6e4a','burnt orange':'#cc5500',
      'butter':'#f8e8a0','chambray':'#a8bdd0','chestnut':'#954535',
      'citrus':'#f5a623','cobalt blue':'#0047ab','cool heather grey':'#b0b8c0',
      'crunchberry':'#c0325a','denim':'#1560bd','espresso':'#3b1a0a',
      'flo blue':'#5b8ed6','forest green':'#228b22','heather grey':'#b0b0b0',
      'hydrangea':'#9b7fc2','kelly green':'#4cbb17','light gray':'#d3d3d3',
      'light green':'#90ee90','light pink':'#ffb6c1','mustard':'#ffdb58',
      'oatmeal heather':'#d4c9b0','off white':'#f5f0e8','parchment':'#f1e9d2',
      'pepper':'#595959','periwinkle':'#ccccff','royal blue':'#4169e1',
      'royal caribe':'#007cc3','true navy':'#003070','watermelon':'#fc6c85',
      'white heather':'#f0ece8','blue frame':'#2255cc','gray lens':'#888888',
      'green lens':'#228822','brown lens':'#7a4a2a','yellow lens':'#f5c842'
    };

    function applySwatchColors() {
      document.querySelectorAll('[data-swatch-name]').forEach(function (el) {
        var name = el.getAttribute('data-swatch-name');
        var hex = colorMap[name];
        if (!hex) {
          for (var key in colorMap) {
            if (name.indexOf(key) !== -1) { hex = colorMap[key]; break; }
          }
        }
        if (hex) el.style.setProperty('background', hex, 'important');
      });
    }

    // Run on initial page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applySwatchColors);
    } else {
      applySwatchColors();
    }

    // Watch for Quick Add modal injection
    var observer = new MutationObserver(function (mutations) {
      var found = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if (node.matches('[data-swatch-name]') || (node.querySelector && node.querySelector('[data-swatch-name]'))) {
              found = true;
            }
          }
        });
      });
      if (found) {
        setTimeout(applySwatchColors, 50);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

})();



document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);
  const locomotiveScroll = new LocomotiveScroll({
    autoRaf: true,
  });
  // searchScroll(locomotiveScroll);
  initBlobAnimation();
  flipLogo();
  initButtonCharacterStagger()
});

function searchScroll(scroller) {
  customElements.whenDefined('header-search-popdown').then(() => {
  const header = document.querySelector('header.theme__header');
  
  if (!header) return;

  const observer = new MutationObserver(() => {
    const isOpen = header.querySelector('header-search-popdown.is-open');
    if (isOpen) {
      scroller.stop();
    } else {
      scroller.start();
    }
  });

  observer.observe(header, {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true
  });
});
}

function flipLogo() {
  const section = document.querySelector(".logo-strip-section");
  if (!section) return;

  const mm = gsap.matchMedia();

  // mm.add("(min-width: 1025px)", () => {

    const bigLogo = document.querySelector(".logo-strip-img");
    const headerLogos = document.querySelectorAll(".header__logo");
    const navbarHeight = document.querySelector('.theme__header').offsetHeight - 4;

    // initial state
    gsap.set(headerLogos, { autoAlpha: 0 });
    gsap.set(bigLogo, { autoAlpha: 1 });

    // if (!document.querySelector("html[data-scroll-locked]")) return;
    gsap.to(bigLogo, {
      scale: 0.15,
      y: 70, 
      ease: "none",
      scrollTrigger: {
        trigger: ".logo-strip-section",
        start: `top-=${navbarHeight} top`,
        end: "+=200",
        scrub: true,
        markers: false,
        invalidateOnRefresh: true,

        onLeave: () => {
          gsap.to(bigLogo, { autoAlpha: 0, duration: 0.1 });
          gsap.to(headerLogos, { autoAlpha: 1, duration: 0.1 });
          document.querySelector(".theme__header").style.setProperty("--bg", "white");
          document.querySelector(".collection__sidebar__slider")?.style.setProperty(
            "--sidebar-height", `calc(100vh - ${navbarHeight}px)`
          );
        },

        onEnterBack: () => {
          gsap.to(bigLogo, { autoAlpha: 1, duration: 0.1 });
          gsap.to(headerLogos, { autoAlpha: 0, duration: 0.1 });
          document.querySelector(".theme__header").style.setProperty("--bg", "transparent");
          document.querySelector(".collection__sidebar__slider")?.style.setProperty(
            "--sidebar-height", "70vh"
          );
        },
      }
    });

  // });
}

function initBlobAnimation(options = {}) {
  const {
    sectionSelector = "[data-blob-section]",
    drawDuration = 0.5,
    fadeDuration = 0.2,
    fillColor = "#A7C8E7"
  } = options;

  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const triggerStart = section.dataset.blobTrigger || "top 80%";

  const svgs = [...section.querySelectorAll("[data-blob-svg]")];
  svgs.sort((a, b) => a.dataset.blobOrder - b.dataset.blobOrder);

  const master = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top center",
      end: "bottom center",
      markers: false,
      toggleActions: "play reset play reset"
    },
    onStart: () => {
      svgs.forEach((svg) => {
        gsap.set(svg.querySelector("path:first-child"), { fill: "transparent" });
      });
    }
  });

  svgs.forEach((svg) => {
    const blob = svg.querySelector("path:first-child");
    const letters = svg.querySelectorAll("path:not(:first-child)");
    const delay = svg.dataset.blobDelay || "0";

    gsap.set(blob, { fill: "transparent" });

    const tl = gsap.timeline();

    tl.from(blob, {
      duration: drawDuration,
      drawSVG: "0 0",
      ease: "none"
    })
      .to(blob, {
        fill: fillColor,
        duration: 0.4
      })
      .from(
        letters,
        {
          duration: fadeDuration,
          opacity: 0,
          ease: "power2.out",
          stagger: 0.05
        },
        `-=${fadeDuration}`
      );

    master.add(tl, delay);
  });
}

function initButtonCharacterStagger() {
  const offsetIncrement = 0.01;

  function splitTextToChars(target) {
    // Pehle check karo ke already split ho chuka hai
    if (target.querySelector('.btn-text-inner')) return;

    // Sirf pure text nodes se text nikalo
    let text = '';
    target.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        text += node.textContent;
      }
    });
    text = text.trim();
    if (!text) return;

    // Target ke sirf text nodes hataao, baaki (sup, icons) rehne do
    const childrenToKeep = [];
    target.childNodes.forEach(node => {
      if (node.nodeType !== Node.TEXT_NODE) {
        childrenToKeep.push(node.cloneNode(true));
      }
    });

    target.innerHTML = '';

    // Text inner wrapper
    const inner = document.createElement('span');
    inner.className = 'btn-text-inner';

    [...text].forEach((char, index) => {
      const el = document.createElement('span');
      el.className = 'char';
      el.textContent = char;
      el.style.transitionDelay = `${index * offsetIncrement}s`;
     if (char === ' ') {
      el.innerHTML = '&nbsp;';
      el.classList.add('char--space');
    }
      inner.appendChild(el);
    });

    target.appendChild(inner);

    // Sup tags wapas lagao (e.g. product counts)
    childrenToKeep.forEach(child => target.appendChild(child));
  }

  // ─── BUTTONS ───────────────────────────────────────────
  document.querySelectorAll('.btn:not(.search-submit)').forEach(btn => {
    const target = btn.querySelector('span') || btn;
    splitTextToChars(target);
  });

  // ─── HERO DESCRIPTION ──────────────────────────────────
  document.querySelectorAll('.hero__description').forEach(para => {
    splitTextToChars(para);
  });

  // ─── HEADER: TOP LEVEL NAV LINKS ───────────────────────
  // "Shop", "Our Story" etc. — .navtext ke andar text hai
  document.querySelectorAll('.header__menu .navlink--toplevel .navtext').forEach(el => {
    splitTextToChars(el);
  });

  // ─── HEADER: MEGA MENU PARENT LINKS ────────────────────
  /* "Shop By Category", "Shop By Collection"
  document.querySelectorAll('.navlink--child .navtext').forEach(el => {
    splitTextToChars(el);
  });

  // ─── HEADER: MEGA MENU CHILD LINKS ─────────────────────
  // "All", "Bottoms", "Dresses", "Spring", etc.
  document.querySelectorAll('.navlink--grandchild .navtext').forEach(el => {
    splitTextToChars(el);
  }); */

  // ─── HEADER: DESKTOP RIGHT BUTTONS (Cart, Account) ─────
  document.querySelectorAll('.header__desktop__buttons .navlink .navtext').forEach(el => {
    splitTextToChars(el);
  });

  // ─── HEADER: MOBILE NAV TEXT ────────────────────────────
  document.querySelectorAll('.header__mobile .navtext').forEach(el => {
    // Menu toggle text
    if (el.closest('.kj-menu-toggle')) {
      // Sirf "Menu" text node split karo, arrow span chhoddo
      splitTextToChars(el);
      return;
    }
    splitTextToChars(el);
  });

  // ─── FOOTER: QUICK LINKS ───────────────────────────────
  document.querySelectorAll('.footer__quicklinks a').forEach(link => {
    splitTextToChars(link);
  });

  // ─── FOOTER: CREDIT LINK ───────────────────────────────
  document.querySelectorAll('.footer__credit-text a').forEach(link => {
    splitTextToChars(link);
  });
}


const accordions = document.querySelectorAll('.product__block--accordion-clear');
if (accordions.length) {
  accordions[accordions.length - 1].classList.add('accordion-last');
}

const media = document.querySelector(".ith-media");
const overlays = document.querySelectorAll(".ith-overlay-multi-img");

if (media && overlays.length) {
  gsap.set(overlays, { scale: 0.8, opacity: 0 });

  gsap.to(overlays, {
    scale: 1,
    opacity: 1,
    ease: "power2.out",
    stagger: 0.2,
    scrollTrigger: {
      trigger: media,
      start: "top center",
      markers: false,
      toggleActions: "play none none reverse",
    },
  });
}

//SIZE GUIDE FIX MOBILE
(function () {
  function initSizeGuideScroll() {
    document.querySelectorAll('.product-modal__content .rte__table-wrapper').forEach((wrapper) => {
      if (wrapper.classList.contains('ww-size-ready')) return;

      wrapper.classList.add('ww-size-ready');
      wrapper.setAttribute('data-scroll-lock-scrollable', '');
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-popup-open]')) {
      setTimeout(initSizeGuideScroll, 100);
      setTimeout(initSizeGuideScroll, 500);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuideScroll);
  } else {
    initSizeGuideScroll();
  }


  
})();